/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';

/**
 * A small wrapper around `React.useEffect`; used for ignoring the first change detection.
 */
export const useDelayedEffect = (effect: React.EffectCallback, deps?: React.DependencyList) => {
    const [initialized, setInitialized] = React.useState(false);

    React.useEffect(() => {
        if (initialized) {
            effect();

            return;
        }

        setInitialized(true);
    }, deps);
};
